import React from 'react';
import {
    makeStyles,
    Card,
    CardContent,
    Typography,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
} from '@material-ui/core';
import { Receipt as FaturaIcon } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
    subtitulo: {
        color: theme.palette.text.primary
    },
    texto: {
        color: theme.palette.text.secondary,
        marginTop: theme.spacing(1)
    },
    faturaIcon: {
        color: theme.palette.primary[200]
    },
    listItemIcon: {
        minWidth: 30
    },
    gutters: {
        padding: 0
    }
}));

function CardFaturamentoInexistente() {
    const classes = useStyles();

    return (
        <Card>
            <CardContent>
                <List>
                    <ListItem classes={{ gutters: classes.gutters }}>
                        <ListItemIcon classes={{ root: classes.listItemIcon }}>
                            <FaturaIcon className={classes.faturaIcon} />
                        </ListItemIcon>
                        <ListItemText>
                            <Typography variant='h5'
                                color='primary'>
                                Fatura
                            </Typography>
                        </ListItemText>
                    </ListItem>
                </List>
                <Typography variant="h5"
                    className={classes.subtitulo}>
                    Não se preocupe! <span aria-hidden="true" role="img">😃</span>
                </Typography>
                <Typography variant='body2'
                    className={classes.texto}>
                    Ainda não existe nenhuma pendência de pagamento. Em breve você terá acesso à sua primeira fatura.
                </Typography>
            </CardContent>
        </Card>
    );
}

export default CardFaturamentoInexistente;